import { Link } from "react-router-dom";
import { useI18n } from "../context/I18nContext";

// /security — public page you can paste into Facebook replies when someone
// raises card-safety concerns.  Single-source-of-truth for "is this site safe?"
export default function Security() {
  const { t } = useI18n();
  return (
    <div className="min-h-screen bg-[#F4F4F4] text-black" data-testid="security-page">
      <section className="max-w-4xl mx-auto px-5 sm:px-10 pt-12 sm:pt-16 pb-10">
        <div className="font-mono-civic text-xs uppercase tracking-[0.3em] text-[#E00000] flex items-center gap-2" style={{ fontWeight: 900 }}>
          <span className="w-2 h-2 bg-[#E00000]" />
          {t("security_tag")}
        </div>
        <h1
          className="mt-3 font-serif-display text-black leading-[0.95] text-5xl sm:text-6xl md:text-7xl"
          style={{ fontWeight: 800 }}
          data-testid="security-h1"
        >
          {t("security_h1")}
        </h1>
        <p className="mt-5 text-black max-w-2xl text-base sm:text-lg" style={{ fontWeight: 700 }}>
          {t("security_lede")}
        </p>
      </section>

      <section className="border-y-2 border-black bg-white">
        <div className="max-w-4xl mx-auto px-5 sm:px-10 py-10 sm:py-12">
          <div className="font-mono-civic text-xs uppercase tracking-[0.3em] text-[#E00000]" style={{ fontWeight: 900 }}>
            {t("security_q1_tag")}
          </div>
          <h2 className="mt-2 font-serif-display text-3xl sm:text-4xl leading-tight" style={{ fontWeight: 800 }}>
            {t("security_q1_h")}
          </h2>
          <p className="mt-4 text-base sm:text-lg" style={{ fontWeight: 600 }}>
            {t("security_q1_p1")}
          </p>
          <p className="mt-3 text-base sm:text-lg" style={{ fontWeight: 600 }}>
            {t("security_q1_p2")}
          </p>
        </div>
      </section>

      <section className="border-b-2 border-black bg-[#F4F4F4]">
        <div className="max-w-4xl mx-auto px-5 sm:px-10 py-10 sm:py-12">
          <div className="font-mono-civic text-xs uppercase tracking-[0.3em] text-[#E00000]" style={{ fontWeight: 900 }}>
            {t("security_q2_tag")}
          </div>
          <h2 className="mt-2 font-serif-display text-3xl sm:text-4xl leading-tight" style={{ fontWeight: 800 }}>
            {t("security_q2_h")}
          </h2>
          <ul className="mt-5 space-y-3 text-base" style={{ fontWeight: 700 }}>
            <li className="flex items-start gap-3" data-testid="security-fact-1">
              <span className="text-[#E00000] mt-0.5 font-mono-civic">01</span>
              <span>{t("security_fact_1")}</span>
            </li>
            <li className="flex items-start gap-3" data-testid="security-fact-2">
              <span className="text-[#E00000] mt-0.5 font-mono-civic">02</span>
              <span>{t("security_fact_2")}</span>
            </li>
            <li className="flex items-start gap-3" data-testid="security-fact-3">
              <span className="text-[#E00000] mt-0.5 font-mono-civic">03</span>
              <span>{t("security_fact_3")}</span>
            </li>
            <li className="flex items-start gap-3" data-testid="security-fact-4">
              <span className="text-[#E00000] mt-0.5 font-mono-civic">04</span>
              <span>{t("security_fact_4")}</span>
            </li>
            <li className="flex items-start gap-3" data-testid="security-fact-5">
              <span className="text-[#E00000] mt-0.5 font-mono-civic">05</span>
              <span>{t("security_fact_5")}</span>
            </li>
          </ul>
        </div>
      </section>

      <section className="border-b-2 border-black bg-white">
        <div className="max-w-4xl mx-auto px-5 sm:px-10 py-10 sm:py-12">
          <div className="font-mono-civic text-xs uppercase tracking-[0.3em] text-[#E00000]" style={{ fontWeight: 900 }}>
            {t("security_q3_tag")}
          </div>
          <h2 className="mt-2 font-serif-display text-3xl sm:text-4xl leading-tight" style={{ fontWeight: 800 }}>
            {t("security_q3_h")}
          </h2>
          <p className="mt-4 text-base sm:text-lg" style={{ fontWeight: 600 }}>
            {t("security_q3_p")}
          </p>
        </div>
      </section>

      <section className="border-b-2 border-black bg-[#F4F4F4]">
        <div className="max-w-4xl mx-auto px-5 sm:px-10 py-10 sm:py-12">
          <div className="font-mono-civic text-xs uppercase tracking-[0.3em] text-[#E00000]" style={{ fontWeight: 900 }}>
            {t("security_q4_tag")}
          </div>
          <h2 className="mt-2 font-serif-display text-3xl sm:text-4xl leading-tight" style={{ fontWeight: 800 }}>
            {t("security_q4_h")}
          </h2>
          <p className="mt-4 text-base sm:text-lg" style={{ fontWeight: 600 }}>
            {t("security_q4_p")}
          </p>
        </div>
      </section>

      <section className="bg-black text-white">
        <div className="max-w-4xl mx-auto px-5 sm:px-10 py-14 text-center">
          <h2 className="font-serif-display text-3xl sm:text-5xl leading-tight" style={{ fontWeight: 800 }}>
            {t("security_cta_h")}
          </h2>
          <p className="mt-4 max-w-xl mx-auto text-base sm:text-lg" style={{ fontWeight: 700 }}>
            {t("security_cta_p")}
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/register"
              className="inline-flex items-center justify-center bg-[#E00000] text-white uppercase tracking-widest px-8 py-4 border-2 border-[#E00000] text-sm"
              style={{ fontWeight: 900 }}
              data-testid="security-cta-signup"
            >
              {t("security_cta_btn_signup")} →
            </Link>
            <Link
              to="/home"
              className="inline-flex items-center justify-center bg-transparent text-white uppercase tracking-widest px-8 py-4 border-2 border-white text-sm"
              style={{ fontWeight: 900 }}
              data-testid="security-cta-home"
            >
              {t("security_cta_btn_home")}
            </Link>
          </div>
          <div className="mt-6 font-mono-civic text-[10px] uppercase tracking-widest text-white/60" style={{ fontWeight: 800 }}>
            {t("security_cta_micro")}
          </div>
        </div>
      </section>
    </div>
  );
}
